module.exports = __webpack_public_path__ + "img/timer-clock.89b51a33.png";